import { getProviderDefinition, validateImageOrigin } from '../provider-allowlist.js';
export class PixelAdapter {
    provider = 'PIXEL';
    isLoaded = true;
    load(_integration, _ctx) {
        // Image pixels do not preload; they fire per event.
    }
    track(event, integration, ctx) {
        if (typeof window === 'undefined')
            return;
        const definition = getProviderDefinition(integration.provider);
        const src = integration.configuration.src;
        if (typeof src !== 'string' || src.length === 0) {
            ctx.logger.warn('Pixel adapter: missing src', { integrationId: integration.id });
            return;
        }
        if (definition !== undefined) {
            if (validateImageOrigin(definition, src) === null) {
                ctx.logger.warn('Pixel adapter: invalid or disallowed src', {
                    integrationId: integration.id,
                    src,
                });
                return;
            }
        }
        else {
            ctx.logger.warn('Pixel adapter: unknown provider', { provider: integration.provider });
            return;
        }
        const pixel = document.createElement('img');
        pixel.src = `${src}?event=${encodeURIComponent(event.kind)}&_r=${Date.now().toString()}`;
        pixel.width = 1;
        pixel.height = 1;
        pixel.alt = '';
        pixel.style.display = 'none';
        document.body.appendChild(pixel);
    }
}
//# sourceMappingURL=pixel-adapter.js.map